import quarkusApi from '../api/quarkusApi';

// Gera as tarefas do dia a partir das tarefas recorrentes. O backend deixou de fazer isso por
// agendamento, então a geração acontece quando o usuário entra na tela de tarefas.
// A operação é idempotente e nunca deve impedir a listagem: se falhar, seguimos com o GET.
export function generateTodayTasks() {
  return quarkusApi
    .post('/recurrent-tasks/generate-today', null, {
      headers: { Authorization: sessionStorage.getItem('token') },
    })
    .catch((returnFromApi) => {
      console.error('ops! ocorreu um erro' + returnFromApi);
    });
}
